import { Box } from '@chakra-ui/react';
import React from 'react';

import { ReactSelectAsyncPaginate } from 'components/ReactSelect';

interface ICheckboxSelectAsync {
  loadOptions: any;
  optionSelected: any;
  handleOptionChange: ([]: Array<any>) => void;
  selectProps?: any;
  isLoading?: boolean;
}

const CheckboxSelectAsync: React.FC<ICheckboxSelectAsync> = ({
  loadOptions,
  optionSelected,
  handleOptionChange,
  isLoading = false,
  selectProps,
}) => {
  const allOption = {
    label: 'Select all',
    value: '*',
  };

  return (
    <Box w="100%">
      <ReactSelectAsyncPaginate
        loadOptions={loadOptions}
        value={optionSelected}
        additional={{
          page: 1,
        }}
        debounceTimeout={300}
        hasCheckbox
        isClearable
        isMulti
        isLoading={isLoading}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        onChange={(selected: any, event: any) => {
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === allOption.value) {
              return handleOptionChange([allOption, ...optionSelected]);
            }
            let result = [];
            if (selected.length === optionSelected.length) {
              if (selected.includes(allOption)) {
                result = selected.filter((option: any) => option.value !== allOption.value);
              } else if (event.action === 'select-option') {
                result = [allOption, ...optionSelected];
              }
              return handleOptionChange(result);
            }
          }

          return handleOptionChange(selected);
        }}
        {...selectProps}
      />
    </Box>
  );
};

export default CheckboxSelectAsync;
